"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toPlural = void 0;
const toPlural = (str) => {
    if (['api_key', 'user_api_key_created_by',].includes(str))
        return `${str}s`;
    const lastChar = str.substr(-1);
    return `${lastChar === 'y' ? `${str.substr(0, str.length - 1)}ie` : str}${['s', 'x',].includes(lastChar) ? 'es' : 's'}`;
};
exports.toPlural = toPlural;
